import { helper } from '@ember/component/helper';

export type FlattenedValibotErrors = {
  [key: string]: readonly string[] | undefined;
};
export type Touched = {
  [key: string]: boolean;
};

/**
 * Returns mutable field errors from flattened Valibot results. Suppresses them before submission or
 * for untouched fields when a touched map is provided.
 */

function errorsForValibotField(
  [field]: [string],
  {
    schemaErrors = {},
    touched = {},
    hasSubmitted = true,
  }: { schemaErrors?: FlattenedValibotErrors; touched?: Touched; hasSubmitted?: boolean }
): string[] {
  if (
    (!field && field !== '0') ||
    !schemaErrors ||
    (Object.keys(touched).length && !touched[field]) ||
    !hasSubmitted
  ) {
    return [];
  }
  const fieldErrors = schemaErrors[field];
  // Frontile requires a mutable errors array; copy without modifying the source.
  return fieldErrors ? [...fieldErrors] : [];
}

export default helper(errorsForValibotField);
